'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.prevModalWindow = exports.nextModalWindow = exports.clearModalWindows = exports.shiftModalWindow = exports.popModalWindow = exports.insertModalWindow = exports.pushModalWindow = undefined;

var _ActionTypes = require('./ActionTypes');

var _utils = require('./utils');

var pushModalWindow = exports.pushModalWindow = function pushModalWindow(types, props) {
    return {
        type: _ActionTypes.PUSH_MODAL_WINDOW,
        payload: {
            types: (0, _utils.toArray)(types),
            props: (0, _utils.toArray)(props)
        }
    };
};

var insertModalWindow = exports.insertModalWindow = function insertModalWindow(types, props) {
    return {
        type: _ActionTypes.INSERT_MODAL_WINDOW,
        payload: {
            types: (0, _utils.toArray)(types),
            props: (0, _utils.toArray)(props)
        }
    };
};

var popModalWindow = exports.popModalWindow = function popModalWindow(values) {
    return {
        type: _ActionTypes.POP_MODAL_WINDOW,
        payload: {
            values: values
        }
    };
};

var shiftModalWindow = exports.shiftModalWindow = function shiftModalWindow(values) {
    return {
        type: _ActionTypes.SHIFT_MODAL_WINDOW,
        payload: {
            values: values
        }
    };
};

var clearModalWindows = exports.clearModalWindows = function clearModalWindows() {
    return {
        type: _ActionTypes.CLEAR_MODAL_WINDOWS
    };
};

var nextModalWindow = exports.nextModalWindow = function nextModalWindow() {
    return {
        type: _ActionTypes.NEXT_MODAL_WINDOW
    };
};

var prevModalWindow = exports.prevModalWindow = function prevModalWindow() {
    return {
        type: _ActionTypes.PREV_MODAL_WINDOW
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-promising-modals/lib/actions.js
// module id = 584
// module chunks = 0